export const profileData = {
  id: 11,
  name: "Randone Vai",
  img: "https://i.pravatar.cc/150?u=",
  email: "iftakhar.radone@gmail.com",
  auth: { isAdmin: true, isVerified: true },
};
export const profileData2 = {
  id: 10,
  name: "Dorella Rizzotto",
  img: "https://i.pravatar.cc/150?u=",
  email: "drizzotto9@stumbleupon.com",
  auth: { isAdmin: false, isVerified: false },
};
